import type { ReactNode } from 'react';
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { theme } from '@/shared/theme/theme';
import { AuthInitializer } from '@/shared/auth/AuthInitializer';
import { AppLoader } from '@/shared/ui/AppLoader';
import { AppNotification } from '@/shared/ui/AppNotification';
import { MaintenanceOverlay } from '@/shared/ui/MaintenanceOverlay';
import { env } from '@/shared/config/env';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

type Props = {
  children: ReactNode;
};

export function AppProviders({ children }: Props) {
  return (
    <QueryClientProvider client={queryClient}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <AppLoader />
        <AppNotification />
        {env.maintenance ? <MaintenanceOverlay /> : (
          <AuthInitializer>
            {children}
          </AuthInitializer>
        )}
      </MuiThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
